/* info-to-hint:
 *
 * Transform information sources to hints
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(function () {
    $(doc).on("bb:preHandleData", function (event, data) {
      if (data && data.groups && data.informationsources) {
        $.each(data.groups, function (_, group) {
          $.each(group.controls, function (_, control) {
            if (control.hint) {
              var src = {
                content: control.hint,
                isurl: false,
                belongsto: control._originalisfor || control._originalid,
                groupguid: control._originalisfor || control._originalid
              };
              data.informationsources.push(src);
              delete control.hint;
            }
          });
        });
      }
    });
  });
})(jQuery, window, document);
